import { Modal } from "antd";
import React from "react";
import styles from "./GenerateSuccessModal.module.scss";
import AcceptIcon from "../../../assets/images/accept-icon.svg";
import { SuccesModalConsts } from "./constants";
import TNButton from "../../../reusable-components/TNButton";
import { ButtonShape, ButtonSize } from "../../../enums/ButtonAttributesEnums";
import { useHistory } from "react-router-dom";
import { appRoutes } from "../../../constants/appRoutes";
import ConditionalRender from "../../../reusable-components/ConditionalRender";

interface GenerateSuccessModalProps {
  isOpen: boolean;
  handleClose: () => void;
  ticketCount?: number;
  hasInvoiceAccess?: boolean;
}

const GenerateSuccessModal = (props: GenerateSuccessModalProps) => {

  const navigate = useHistory();

    const { isOpen = false, handleClose, ticketCount, hasInvoiceAccess } = props;
    const { HEADER, getMessage, GO_TO_INVOICE_MANAGEMENT, BUTTON_CLASS } = SuccesModalConsts;

  const handleNavigateToInvoiceManagement = () => {
    handleClose();
    navigate.push(appRoutes.INVOICE_MANAGEMENT);
    }

  return (
    <Modal
      visible={isOpen}
      className={styles.allApprovedModal}
      footer={null}
      centered
      onCancel={handleClose}
      maskClosable
      destroyOnClose
    >
      <div className={styles.allApprovedModalContent}>
        <img className={styles.allApprovedModalIcon} src={AcceptIcon} />
        <div className={styles.allApprovedModalText}>
          <h2>{HEADER}</h2>
          <h4>
            <span>{ticketCount}</span>
            {getMessage(ticketCount)}
          </h4>
        </div>
        <ConditionalRender visible={hasInvoiceAccess}>
          <div className={styles.allApprovedModalButtons}>
            <TNButton
              size={ButtonSize.LARGE}
              shape={ButtonShape.DEFAULT}
              className={BUTTON_CLASS}
              text={GO_TO_INVOICE_MANAGEMENT}
              onClick={handleNavigateToInvoiceManagement}
            />
          </div>
        </ConditionalRender>
      </div>
    </Modal>
  );
};

export default GenerateSuccessModal;
